import { useCallback } from 'react';

import { FilterCondition, useEngine } from '../aiem/engine/hooks';
import AIEnginesPage from '../components/AIEnginesPage/AIEnginesPage';

const allWorkspaces = 'workspaces/-';

export default function AdminAIEnginesPage() {
  const { searchEngines } = useEngine();
  const fetchEngines = useCallback(
    async (filter?: FilterCondition[]) => {
      return await searchEngines(filter || [], allWorkspaces);
    },
    [searchEngines]
  );
  return <AIEnginesPage admin title="Admin AI Engines" fetchEngines={fetchEngines} workspace={allWorkspaces} />;
}
